import React, { forwardRef, useState, useLayoutEffect, Ref } from "react";
import classNames from "classnames";

import ModalBackDrop from "./ModalBackDrop";
import preventBackgroundScrolling from "utils/preventBackgroundScrolling";
import styles from "./Modal.module.scss";

interface Props {
    isVisible: boolean;
    children: React.ReactNode;
    onClickBackdrop?: () => void;
    classes?: {
        root?: string;
        container?: string;
        backdrop?: string;
    };
}

const Modal = forwardRef(
    ({ isVisible, children, classes, onClickBackdrop }: Props, ref: Ref<HTMLDivElement>) => {
        const [showModal, setShowModal] = useState(false);

        function toggleBackground(active: boolean) {
            if (active) {
                preventBackgroundScrolling.start();
            } else {
                preventBackgroundScrolling.stop();
            }
        }
        useLayoutEffect(() => {
            toggleBackground(isVisible);
            setShowModal(isVisible);
            return () => {
                preventBackgroundScrolling.stop();
            };
        }, [isVisible]);
        function stopPropagation(e: React.MouseEvent) {
            e.stopPropagation();
        }
        return (
            <>
                <div
                    ref={ref}
                    className={classNames(classes?.root, styles["modal"], {
                        [styles["modal--open"]]: showModal,
                    })}
                    role="dialog"
                    aria-hidden={!showModal}
                    tabIndex={-1}
                    onClick={onClickBackdrop}
                >
                    <div
                        className={classNames(styles["modal-container"], classes?.container)}
                        role="document"
                        onClick={stopPropagation}
                    >
                        {children}
                    </div>
                </div>
                {showModal ? (
                    <ModalBackDrop
                        onClick={onClickBackdrop}
                        className={classNames(classes?.backdrop)}
                    />
                ) : (
                    undefined
                )}
            </>
        );
    },
);

export default Modal;
